<template>
  <div class="text-24px p-4 sm:p-12 bg-lblue">
    <div
      class="bg-white px-5 py-4 rounded overflow-hidden border border-borderGrey"
    >
      <div class="flex justify-between items-center flex-col sm:flex-row">
        <div class="u-h2 font-semibold mb-4 sm:mb-0 text-center sm:text-left">
          {{ label }}
        </div>

        <div
          class="ml-4 accent-currency-box bg-accent text-white rounded py-2 px-8 flex font-medium"
        >
          <div v-if="!isFreeText" class="mr-6">{{ currency }}</div>
          <div v-if="!isFreeText" class="flex-auto text-center mx-2">{{ formattedValue }}</div>
          <vue-numeric
            v-if="isFreeText"
            :min="+input.min || 0"
            :currency="$root.currency"
            v-model="$root[input.name]"
            class="numeric bg-accent font-semibold"
          />
        </div>
      </div>
    </div>


    <div v-if="!isFreeText" class="text-center mt-8">
      <form class="range flex justify-between">
        <span class="mr-4 font-semibold">
          {{ currency }}{{ input.min_text }}
        </span>

        <div class="range-container flex-auto flex items-center">
          <div class="w-full">
            <VueSlider
              height="10px"
              dot-size="20"
              v-model="$root[input.name]"
              :interval="+input.interval || 1000"
              :tooltip-formatter="formatterWithCurrency"
              :min="+input.min"
              :max="+input.max"
            />
          </div>
        </div>

        <span class="ml-4 font-semibold">
          {{ currency }}{{ input.max_text }}
        </span>
      </form>
    </div>
  </div>
</template>

<script>
// App.vue
import VueSlider from 'vue-slider-component';

export default {
  props: ['label', 'input'],
  components: { VueSlider },
  data: (self) => {
    const value = self.$root.s1Raising;

    return {
      // Add commas to value
      value,
      formatter: (v) => `${('' + v).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`,
    };
  },

  computed: {
    isFreeText() {
      return this.input.free_text_input === true;
    },
    currency() {
      return this.$root.currency;
    },
    formattedValue() {
      return this.formatter(this.$root[this.input.name]);
    },
    formatterWithCurrency() {
      return this.currency + this.formatter(this.$root[this.input.name]);
    },
  },
  mounted() {
    if (this.$root[this.input.name] > +this.input.max) {
      this.$root[this.input.name] = (+this.input.max)/2;
    }
  },
};
</script>

<style lang="scss">
.accent-currency-box {
  @screen sm {
    min-width: 245px;
  }
}

input.numeric {
  padding:0 .5em!important;
  border: none !important;
}

/* Set the theme color of the component */
$themeColor: #6062ff;

/* import theme style */
@import '~vue-slider-component/lib/theme/default.scss';
</style>
